import { useState, useEffect } from "react";

const useSubdomain = () => {
  const [subdomain, setSubdomain] = useState(null);

  useEffect(() => {
    const hostname = window.location.hostname; // e.g., milton.local, sub.example.com
    const parts = hostname.split(".");

    // Handle domains like "milton.local"
    if (parts.length === 2 && parts[1] === "local") {
      setSubdomain(parts[0]); // Extract "milton"
    }
    // Handle standard subdomains like "sub.example.com"
    else if (parts.length > 2) {
      setSubdomain(parts[0]); // Extract "sub"
    }
  }, []);

  if (subdomain === '192') {
    setSubdomain('milton');
  }
  return subdomain;
};

export default useSubdomain;
